import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/common/right.png'


const _withScopeId = n => (_pushScopeId("data-v-59f8291d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-list" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = { class: "list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, "BK", -1))
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info1" }
const _hoisted_10 = { class: "right" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { class: "number" }
const _hoisted_13 = { class: "time" }

import { useRouter } from "vue-router";
import Title from "@/components/MainTitle.vue";
import { Block } from "@/api/api";
import HelperTools from "@/utils/helper";

interface Props {
  blocks: Block[];
  showTime: number[];
}

export default /*#__PURE__*/_defineComponent({
  props: {
    blocks: null,
    showTime: null
  },
  setup(__props: any) {

const props = __props as { blocks: Block[], showTime: number[] }



const router = useRouter();
const toBlockList = () => {
  router.push({
    name: "Blocks",
  });
};
const toBlock = (height: number) => {
  router.push({ name: "Block", params: { Number: height } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Title, {
        title: _ctx.$t('home.block')
      }, null, 8, ["title"]),
      _createElementVNode("div", {
        class: "all",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toBlockList()))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("home.all")) + " ", 1),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.blocks, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          onClick: ($event: any) => (toBlock(item.Number)),
          key: index
        }, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(HelperTools).toFinancialVal(item.Number)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.TxNumber) + " Txns", 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(props.showTime[index] <= 60
                  ? props.showTime[index] + "s"
                  : _unref(HelperTools).getShowDate(props.showTime[index])) + " ago ", 1)
            ])
          ])
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})